
import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Home, Briefcase, Users, LogOut, Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { signOut } from "../lib/supabase";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { debug } from "@/lib/utils";

export function NavBar() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut();
      toast.success("Signed out successfully");
      navigate("/login");
    } catch (error) {
      debug.error("Error signing out:", error);
      toast.error("Failed to sign out");
    }
  };

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  return (
    <header className="fixed top-0 left-0 right-0 bg-white shadow-sm z-10">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <NavLink 
              to="/" 
              className="text-2xl font-bold text-househeld-700 flex items-center gap-2"
            >
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width="30" 
                height="30" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                className="lucide lucide-shield"
              >
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              </svg>
              HouseHeld
            </NavLink>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-4">
            <NavLink
              to="/"
              className={({ isActive }) =>
                `flex items-center px-3 py-2 rounded-md ${
                  isActive 
                    ? "bg-househeld-100 text-househeld-700" 
                    : "text-gray-600 hover:bg-gray-100"
                }`
              }
            >
              <Home className="h-5 w-5 mr-1" />
              <span>Dashboard</span>
            </NavLink>
            <NavLink
              to="/jobs"
              className={({ isActive }) =>
                `flex items-center px-3 py-2 rounded-md ${
                  isActive 
                    ? "bg-househeld-100 text-househeld-700" 
                    : "text-gray-600 hover:bg-gray-100"
                }`
              }
            >
              <Briefcase className="h-5 w-5 mr-1" />
              <span>Jobs</span>
            </NavLink>
            <NavLink
              to="/trades"
              className={({ isActive }) =>
                `flex items-center px-3 py-2 rounded-md ${
                  isActive 
                    ? "bg-househeld-100 text-househeld-700" 
                    : "text-gray-600 hover:bg-gray-100"
                }`
              }
            >
              <Users className="h-5 w-5 mr-1" />
              <span>Trades</span>
            </NavLink>
            <Button 
              variant="ghost" 
              size="sm" 
              onClick={handleSignOut}
              className="flex items-center text-gray-600 hover:text-gray-900 hover:bg-gray-100"
            >
              <LogOut className="h-5 w-5 mr-1" />
              <span>Sign Out</span>
            </Button>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <Button variant="ghost" size="icon" onClick={toggleMenu}>
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </Button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <nav className="md:hidden bg-white pb-4 px-4">
          <div className="flex flex-col space-y-2">
            <NavLink
              to="/"
              className={({ isActive }) =>
                `flex items-center px-3 py-2 rounded-md ${
                  isActive 
                    ? "bg-househeld-100 text-househeld-700" 
                    : "text-gray-600 hover:bg-gray-100"
                }`
              }
              onClick={closeMenu}
            >
              <Home className="h-5 w-5 mr-2" />
              <span>Dashboard</span>
            </NavLink>
            <NavLink
              to="/jobs"
              className={({ isActive }) =>
                `flex items-center px-3 py-2 rounded-md ${
                  isActive 
                    ? "bg-househeld-100 text-househeld-700" 
                    : "text-gray-600 hover:bg-gray-100"
                }`
              }
              onClick={closeMenu}
            >
              <Briefcase className="h-5 w-5 mr-2" />
              <span>Jobs</span>
            </NavLink>
            <NavLink
              to="/trades"
              className={({ isActive }) =>
                `flex items-center px-3 py-2 rounded-md ${
                  isActive 
                    ? "bg-househeld-100 text-househeld-700" 
                    : "text-gray-600 hover:bg-gray-100"
                }`
              }
              onClick={closeMenu}
            >
              <Users className="h-5 w-5 mr-2" />
              <span>Trades</span>
            </NavLink>
            <Button 
              variant="ghost" 
              size="sm" 
              onClick={() => {
                closeMenu();
                handleSignOut();
              }}
              className="flex items-center justify-start text-gray-600 hover:text-gray-900 hover:bg-gray-100"
            >
              <LogOut className="h-5 w-5 mr-2" />
              <span>Sign Out</span>
            </Button>
          </div>
        </nav>
      )}
    </header>
  );
}